module.exports = "fragment DetailedCountryFragment on Country {\n  postalName\n  subdivisions {\n    abbreviationOrName\n  }\n}\n"